import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const url = process.env.REACT_APP_API_URL;
  const [profile, setProfile] = useState({});

  const handleNavigation = (path) => {
    navigate(path);
  };

  const fetchUserData = async () => {
    try {
      const profileRes = await fetch(
        `${url}/register/single/${process.env.REACT_APP_PERFUME_ID}`
      );
      const res = await profileRes.json();
      setProfile(res.users);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo & About */}
        <div className="footer-section">
          <h2 className="footer-logo">
            {profile?.profilePic ? (
              <img
                src={`${url}/uploads/profile/${profile.profilePic}`}
                alt="Logo"
                style={{ height: "40px", objectFit: "contain" }}
              />
            ) : (
              profile?.orignal_logoname || "Armani Makhana Company"
            )}
          </h2>
          <p>
            Armani Makhana Company – Your trusted destination for products.
          </p>
          {/* <div className="social-icons">
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.facebook.com" target="_blank" rel="noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://www.youtube.com" target="_blank" rel="noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
          </div> */}
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li onClick={() => handleNavigation("/")}>Home</li>
            <li onClick={() => handleNavigation("/products")}>Products</li>
            <li onClick={() => handleNavigation("/about")}>About Us</li>
            <li onClick={() => handleNavigation("/contact")}>Contact Us</li>
          </ul>
        </div>

        {/* Customer Service */}
        <div className="footer-section">
          <h3>Customer Service</h3>
          <ul>
            <li onClick={() => handleNavigation("/refund-policy")}>
              Refund Policy
            </li>
            <li onClick={() => handleNavigation("/privacy-policy")}>
              Privacy Policy
            </li>
            <li onClick={() => handleNavigation("/shipping-and-delivery")}>
              Shipping Policy
            </li>
            <li onClick={() => handleNavigation("/terms-and-conditions")}>
              Terms & Conditions
            </li>
            <li onClick={() => handleNavigation("/enquiry-form")}>Enquiry</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Contact Info</h3>
          <p>
            <strong>Phone:</strong> 7977508283
          </p>
          <p>
            <strong>Email:</strong> armanienterpriises@gmail.com
          </p>
          <p>
            <strong>Address:</strong>
          </p>
          <ul>
            <li>
              Mumbai, MH - 400101, India
            </li>
          </ul>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} copy-rights reserved, Designed by <a href="https://100billiontech.com/" target="_blank"
            rel="noreferrer">100billion Tech</a></p>
      </div>
    </footer>
  );
};

export default Footer;
